@if(!isLoading){
  <div data-e2e="loading-container" class="loading">
    <div class="TruckLoader">
      <div data-e2e="loading-msg" class="load"></div>
      <div class="TruckLoader-cab"></div>
      <div class="TruckLoader-smoke"></div></div>
  <hr />
  </div>
}